import { FC } from "react";
import PageTemplate from "../PageTemplate";
import CatalogPage from "./CatalogPage";

const Catalog: FC = () => {
    return <PageTemplate Page={CatalogPage} />;
};

export default Catalog;
